import { AppConfig } from '@yotpo-ui/platform-core';
import { ConfigService } from '@yotpo-ui/core';

export class ApplicationConfig implements AppConfig {
  productLine = 'Reviews & Ratings';
  loginURL = this.configService.getConfig().LoginServiceUrl;
  constructor(private configService: ConfigService) { }
}
